import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import translate from '../../../utils/translations';
import {Button} from '@homeaway/react-buttons';
import {FaqNode} from './FaqNode/FaqNode';
import {LocalizationContext} from '@homeaway/react-localization-components';
import {localizeUrl} from '@homeaway/localization-utils';

import './Faqs.less';

export class Faqs extends React.PureComponent {
    static propTypes = {
        instantBooking: PropTypes.bool,
        translations: PropTypes.shape({}).isRequired,
        tripDetailsUrl: PropTypes.string.isRequired,
        humanReadableBrandName: PropTypes.string.isRequired,
    };

    static defaultProps = {
        translations: {},
    };

    static contextType = LocalizationContext;

    render() {
        const {
            instantBooking,
            translations,
            tripDetailsUrl,
            humanReadableBrandName,
        } = this.props;

        const buttonLabel = (
            <Fragment>
                <span className="hidden-xs">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.faq.cta'
                    )}
                </span>
                <span className="visible-xs-inline">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.faq.ctaShort'
                    )}
                </span>
            </Fragment>
        );

        const vrbocareLink = translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'th.vrbocare.link'
        );
        const programName = translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'th.vrbocare.programname'
        );
        const serviceFeeLink = translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'th.servicefee.link'
        );

        return (
            /* eslint-disable react/no-danger */
            <div className="Faqs confirmation-item">
                <div className="row">
                    <div className="col-xs-12">
                        <h2>
                            {translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.confirmation.faq.title'
                            )}
                        </h2>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: translate(
                                    translations,
                                    'trav-dash/trav-home',
                                    'messages',
                                    'th.confirmation.faq.text'
                                ),
                            }}
                        />
                    </div>
                    {!instantBooking && (
                        <Fragment>
                            <div className="col-sm-6 col-xs-12">
                                <FaqNode
                                    dividerId={'faq1'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text1',
                                        {brandName: humanReadableBrandName}
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title1'
                                    )}
                                />
                                <FaqNode
                                    dividerId={'faq2'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text5'
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title5'
                                    )}
                                />
                                <FaqNode
                                    dividerId={'faq3'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.vrbocare',
                                        {
                                            vrbocareLink,
                                            programName,
                                            serviceFeeLink,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title3'
                                    )}
                                />
                                <FaqNode
                                    dividerId={'faq4'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text6',
                                        {
                                            link: tripDetailsUrl,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title6'
                                    )}
                                />
                            </div>
                            <div className="col-sm-6 col-xs-12">
                                <FaqNode
                                    dividerId={'faq5'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text4',
                                        {
                                            link: tripDetailsUrl,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title4'
                                    )}
                                />
                                <FaqNode
                                    dividerId={'faq6'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text2',
                                        {
                                            link: localizeUrl(
                                                '/traveler/th/bookings',
                                                this.context
                                            ),
                                            brandName: humanReadableBrandName,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title2'
                                    )}
                                />
                                <FaqNode
                                    dividerId={'faq7'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text7',
                                        {
                                            link: tripDetailsUrl,
                                            brandName: humanReadableBrandName,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title7'
                                    )}
                                />
                            </div>
                        </Fragment>
                    )}
                    {instantBooking && (
                        <Fragment>
                            <div className="col-sm-6 col-xs-12">
                                <FaqNode
                                    dividerId={'faq1'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.vrbocare',
                                        {
                                            vrbocareLink,
                                            programName,
                                            serviceFeeLink,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title3'
                                    )}
                                />
                                <FaqNode
                                    dividerId={'faq2'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text5'
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title5'
                                    )}
                                />
                                <FaqNode
                                    dividerId={'faq3'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text7',
                                        {
                                            link: tripDetailsUrl,
                                            brandName: humanReadableBrandName,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title7'
                                    )}
                                />
                            </div>
                            <div className="col-sm-6 col-xs-12">
                                <FaqNode
                                    dividerId={'faq4'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text4',
                                        {
                                            link: tripDetailsUrl,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title4'
                                    )}
                                />
                                <FaqNode
                                    dividerId={'faq5'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text6',
                                        {
                                            link: tripDetailsUrl,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title6'
                                    )}
                                />
                                <FaqNode
                                    dividerId={'faq6'}
                                    text={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.text8',
                                        {
                                            link: tripDetailsUrl,
                                            brandName: humanReadableBrandName,
                                        }
                                    )}
                                    title={translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.confirmation.faq.title8'
                                    )}
                                />
                            </div>
                        </Fragment>
                    )}
                    <div className="col-xs-12 text-center">
                        <div className="Faqs__border hidden-xs" />
                        <Button
                            href={translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.confirmation.faq.ctaLink'
                            )}
                            label={buttonLabel}
                        />
                    </div>
                </div>
            </div>
            /* eslint-enable react/no-danger */
        );
    }
}
